class LineBreakTransformer {
    chunks;
    constructor() {
        // A container for holding stream data until a new line.
        this.chunks = '';
    }
    transform(chunk, controller) {
        // Append new chunks to existing chunks.
        this.chunks = this.chunks + chunk;
        // For each line breaks in chunks, send the parsed lines out.
        const lines = this.chunks.split('\n');
        this.chunks = lines.pop() ?? '';
        lines.forEach((line) => controller.enqueue(line));
    }
    flush(controller) {
        // When the stream is closed, flush any remaining chunks out.
        controller.enqueue(this.chunks);
    }
}
const selectPort = async () => {
    return await navigator.serial.requestPort();
};
const openPort = async (port) => {
    await port.open({ baudRate: 115200 });
    return port;
};
const getReader = (port) => {
    const textDecoder = new TextDecoderStream();
    port.readable?.pipeTo(textDecoder.writable).then(() => {
    });
    return textDecoder.readable
        .pipeThrough(new TransformStream(new LineBreakTransformer()))
        .getReader();
};
const readFromPort = async (port, readHandler) => {
    while (port.readable != null) {
        const reader = getReader(port);
        // try {
        while (true) {
            const { value, done } = await reader.read();
            if (done) {
                reader.releaseLock();
                break;
            }
            readHandler(value);
        }
        // } catch (error) {
        //
        // }
    }
};
const getPortWriter = async (openedPort) => {
    const textEncoder = new TextEncoderStream();
    void textEncoder.readable.pipeTo(openedPort.writable).then(() => {
        console.debug('textEncoder, resolved');
    });
    return textEncoder.writable.getWriter();
};
export const createSerialConnection = async ({ readHandler }) => {
    const port = await selectPort();
    const openedPort = await openPort(port);
    void readFromPort(openedPort, readHandler).then(() => {
        console.debug('readFromPort, resolved');
    });
    return { writer: await getPortWriter(openedPort) };
};
